export const contactTypeOptions = [
  { label: "Email", value: "email" },
  { label: "Phone", value: "phone" },
  { label: "Mobile", value: "mobile" },
  { label: "Fax", value: "fax" },
  { label: "Whatsapp", value: "whatsapp" },
  { label: "Website", value: "website" },
  { label: "Other", value: "other" },
];
